module.exports = __webpack_public_path__ + "static/media/minus-ico.03af6ab5.svg";